import { render, staticRenderFns } from "./giftEdit.vue?vue&type=template&id=18264342&scoped=true"
import script from "./giftEdit.vue?vue&type=script&lang=js"
export * from "./giftEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18264342",
  null
  
)

export default component.exports